import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * React Router does not reset scroll position on navigation by default.
 * So clicking a <Link> to /privacy or /contact from partway down the
 * Home page opens the new route, but the browser stays scrolled to
 * wherever it already was.
 *
 * Mount this once, inside <BrowserRouter> but outside/above <Routes>,
 * and it will scroll the window to the top every time the pathname
 * changes.
 *
 * Usage (in App.js):
 *
 *   import ScrollToTop from './components/ScrollToTop';
 *
 *   function App() {
 *     return (
 *       <BrowserRouter>
 *         <ScrollToTop />
 *         <Routes>
 *           ...
 *         </Routes>
 *       </BrowserRouter>
 *     );
 *   }
 */
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Only auto-scroll-to-top for plain route changes. If the URL has
    // a hash (e.g. someone linked directly to /#testimonials), let the
    // browser/anchor behavior handle scrolling to that section instead
    // of yanking it back to the top.
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;